import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

@Component({
    selector: 'app-delete-file-button',
    templateUrl: './delete-file-button.component.html',
    styleUrls: ['./delete-file-button.component.scss'],
    imports: [SweetAlert2Module]
})
export class DeleteFileButtonComponent implements OnInit {
  @Input() filename: string;
  @Output() deleteEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  deleteAction(event) {
    this.deleteEvent.emit(String(this.filename));
  }
}
